import { l } from '@manychat/manyui'

export const TextImproverValidationRules = {
  textToImprove: {
    min: 5,
    max: 1000,
  },
}

export const TextImproverValidationMessages = {
  getMinMaxValidationMessage: (min: number, max: number) =>
    l.translate('Enter between {min} and {max} characters', {
      min,
      max,
    }),
}
